import { Component, inject, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, Input, signal, OnInit, WritableSignal, OnDestroy } from '@angular/core';
import { PiasLayoutComponent } from '../../../shared/components/pias-layout/pias-layout.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { AbstractControl, FormBuilder, FormGroup, NgSelectOption, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioButton, MatRadioGroup, MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule } from '@angular/material/core';
import { SelectOptions } from '../../../core/interfaces/select-options.interface';
import { MatInputModule } from '@angular/material/input';
import { AdFormSubmitDialog } from '../ad-form-submit/ad-form-submit.dialog';
import { questionnaire4Questions } from '../question-config/questionnaire4-config';
import { questionnaire1Questions } from '../question-config/questionnaire1-config';
import { questionnaire2Questions } from '../question-config/questionnaire2-config';
import { questionnaire3Questions } from '../question-config/questionnaire3-config';
import { MatButtonModule } from '@angular/material/button';
import { DeclarationSectionPayload } from '../ad-interface/adviser-response.model';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
import { PersonaldetailsModel } from '../ad-interface/personaldetails.model';
import { AdService } from '../ad-service/ad-service';
import { PersonalsectionpostModel } from '../ad-interface/personalsectionpost.model';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { MatSelectModule } from '@angular/material/select';
import { SpousesectionpostModel } from '../ad-interface/spousesectionpost.model';
import { MiscellanioussectionpostModel } from '../ad-interface/miscellanioussectionpost.model';
import { GetdetailsModel } from '../ad-interface/getdetails.model';
import { Router } from '@angular/router';
import { ConfirmPopupComponent } from '../../agent-onboarding/new-rep-application/confirm-popup/confirm-popup.component';
import { HttpStatusCode } from 'axios';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-agent-declaration-form',
  providers: [provideMomentDateAdapter(MY_FORMATS)],
  imports: [
    PiasLayoutComponent,
    MatExpansionModule,
    ReactiveFormsModule,
    CommonModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatSelectModule,
    MatOptionModule,
    MatRadioModule,
    MatError,
    MatRadioButton,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule

  ],
  templateUrl: './agent-declaration-form.component.html',
  styleUrl: './agent-declaration-form.component.scss'
})
export class AgentDeclarationFormComponent implements OnInit, AfterViewInit {

  // INJECTIONS
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private adservice = inject(AdService);
  private sessionservice = inject(SessionStorageService);
  private snackmessage = inject(SnackbarService)
  // STATE VARIABLES
  // declarationStatus: string;
  public formGroup!: FormGroup; // Declare here, initialize in ngOnInit
  declarationData!: PersonaldetailsModel;
  public message = 'This field is required';
  // selectedUadsId!: number;
  selectedUadsId = 0;
  formMode = '';
  protected nationalities!: SelectOptions[];
  setSprinner = signal(false);
  showValidationErrors = false;
  readonly = signal(false);


  loggedInRole!: string

  workflowStatus:
    | 'NOT_STARTED'
    | 'IN_PROGRESS'
    | 'SUBMITTED'
    | 'IN_REVIEW'
    | 'RETURNED'
    | 'APPROVED'
    = 'NOT_STARTED';

  canUserEdit = false;

  initialSpouseValue: any;
  initialPersonalValue: any;
  initialMiscellaneousValue: any;
  initialQuestionnaire1Value: any;
  initialQuestionnaire2Value: any;
  initialQuestionnaire3Value: any;
  initialQuestionnaire4Value: any;
  sectionStatuses: Record<string,
    'Not Started' | 'In Progress' | 'Completed'
  > = {};

  uploadedFiles = new Map<string, File>();

  // Assuming these are imported from a constants file
  questionnaire1Questions = questionnaire1Questions;
  questionnaire2Questions = questionnaire2Questions;
  questionnaire3Questions = questionnaire3Questions;
  questionnaire4Questions = questionnaire4Questions;

  personalDetailsFormValid = signal('Not Started');
  spouseDetailsFormValid = signal('Not Started');
  questionnaire1FormValid = signal('Not Started');
  questionnaire2FormValid = signal('Not Started');
  questionnaire3FormValid = signal('Not Started');
  questionnaire4FormValid = signal('Not Started');
  miscellaneousFormValid = signal('Not Started');
  currentStep!: number;
  countries: any;
  validator = '(Optional)';


  constructor() {
    // Keep constructor clean. Do not build forms or setup validators here.
  }


  ngOnInit(): void {
    this.loggedInRole = this.sessionservice.getCurrentUserRole();
    // 1. Build the form FIRST
    this.initializeForm();
    this.getdeclarationstatus();
    // this.loadDeclarationDetails();

    // 2. Setup validators that depend on the form existing
    this.getDropdownOptions();
    this.handleFormStatus();

  }


  ngAfterViewInit() {
    this.loadDeclarationDetails();
    // Any DOM-dependent logic goes here
  }

  /**
   * Initializes the entire form structure
   */
  private initializeForm(): void {
    this.formGroup = this.fb.group({
      // PERSONAL INFO (Static)
      personalInfo: this.fb.group({
        fullName: [''],
        representative_no: [''],
        branch: [''],
        repcode: [''],
        nric: [''],
        nationality: [''],
        otherNationality: [''],
        countryofbirth: [''],
        fin_No: [''],
        email: [''],
        race: [''],
        raceSpecify: [''],
        dob: [''],
        maritalStatus: [''],
        address: [''],
        // postalCode: ['', [Validators.required]],
        homenumber: [''],
        mobilenumber: ['']
      }),

      // SPOUSE (Static)
      spouseInfo: this.fb.group({
        spousename: [''],
        spouse_no: [''],
        spouse_dob: [''],
        spouse_occupation: [''],
        spouse_employer: ['']
      }),

      // QUESTIONS (Dynamic)
      questionnaire1: this.buildQuestions(this.questionnaire1Questions),
      questionnaire2: this.buildQuestions(this.questionnaire2Questions),
      questionnaire3: this.buildQuestions(this.questionnaire3Questions),
      questionnaire4: this.loggedInRole !== 'Advisor' ? this.buildQuestions(this.questionnaire4Questions) : '',



      // MISCELLANEOUS
      miscellaneous: this.fb.group({
        additionalInfo: ['', [Validators.required]],
      })
    });
  }

  // Your existing dynamic builder function
  buildQuestions(questions: any[]) {
    const group: any = {};

    if (!questions || questions.length === 0) {
      console.warn(
        'buildQuestions was called with an empty or undefined question array.'
      );
      return this.fb.group({});
    }

    questions.forEach((q) => {

      const questionGroup = this.fb.group(
        {
          answer: [null, [Validators.required]],

          entityCount: [''],

          noAttachment: [false],

          noAttachmentReason: [''],

          attachment: this.fb.group({
            file: [null],
            fileName: [''],
            documentPath: ['']
          }),

          isVerified: [{ value: false, disabled: true }],

          managerComment: [{ value: '', disabled: true }],
          advisorComment: ['']
        },
        {
          validators: [
            (control: AbstractControl) => {

              const answer = control.get('answer')?.value;

              if (answer === true && q.hasAttachment) {

                const hasFile =
                  !!control.get('attachment.fileName')?.value;

                const noAttachment =
                  !!control.get('noAttachment')?.value;

                const reason =
                  (
                    control.get('noAttachmentReason')
                      ?.value ?? ''
                  )
                    .toString()
                    .trim();

                // File uploaded → valid
                if (hasFile) {
                  return null;
                }

                // No file → must check noAttachment and provide reason
                if (noAttachment && reason !== '') {
                  return null;
                }

                return {
                  attachmentMissing: true
                };
              }

              return null;
            }
          ]
        }
      );

      // Answer change
      questionGroup
        .get('answer')
        ?.valueChanges.subscribe((isYes) => {

          const entityCtrl =
            questionGroup.get('entityCount');

          const reasonCtrl =
            questionGroup.get('noAttachmentReason');

          if (isYes === true) {

            // Entity field mandatory only when inputLabel exists
            if (q.inputLabel) {

              entityCtrl?.setValidators([
                Validators.required
              ]);

            }

          } else {

            // console.log('this')

            entityCtrl?.reset();
            reasonCtrl?.reset();
            // Remove validators
            entityCtrl?.clearValidators();
            reasonCtrl?.clearValidators();
            questionGroup?.get('attachment')?.enable(
              { emitEvent: false }
            );
            questionGroup?.get('attachment')?.setErrors(null);

            // Clear all Yes-related fields
            questionGroup.patchValue(
              {
                entityCount: '',
                noAttachment: false,
                noAttachmentReason: '',
                attachment: {
                  file: null,
                  fileName: '',
                  documentPath: ''
                }
              },
              {
                emitEvent: false
              }
            );
          }

          entityCtrl?.updateValueAndValidity();
          reasonCtrl?.updateValueAndValidity();

          questionGroup.updateValueAndValidity();
          // this.handleFormStatus();
        });

      // No Attachment checkbox change
      questionGroup
        .get('noAttachment')
        ?.valueChanges.subscribe((isChecked) => {
          const attachmentGroup =
            questionGroup.get('attachment');

          if (isChecked) {

            // Clear attachment values
            attachmentGroup?.patchValue(
              {
                file: null,
                fileName: '',
                documentPath: ''
              },
              { emitEvent: false }
            );

            attachmentGroup?.disable({ emitEvent: false });


          } else {

            attachmentGroup?.enable({ emitEvent: false });

          }

          const reasonCtrl =
            questionGroup.get(
              'noAttachmentReason'
            );


          if (isChecked) {

            reasonCtrl?.setValidators([
              Validators.required
            ]);

          } else {

            reasonCtrl?.clearValidators();
            reasonCtrl?.setValue(
              '',
              {
                emitEvent: false
              }
            );

          }

          reasonCtrl?.updateValueAndValidity();

          questionGroup.updateValueAndValidity();
        });
      group[q.id] = questionGroup;
    });

    return this.fb.group(group);
  }


  handleMartialChanges(value: string): void {

    const spouseForm =
      this.formGroup.get('spouseInfo') as FormGroup;

    const controls = [
      spouseForm.get('spousename'),
      spouseForm.get('spouse_no'),
      spouseForm.get('spouse_dob'),
      spouseForm.get('spouse_occupation'),
      spouseForm.get('spouse_employer')
    ];

    if (value?.toLowerCase() === 'married') {

      this.validator = '';

      controls.forEach(control => {
        control?.setValidators([Validators.required]);
        control?.updateValueAndValidity();
      });

      // If married and section is empty
      if (!spouseForm.valid) {
        this.spouseDetailsFormValid.set('In Progress');
      }

    } else {

      this.validator = '(Optional)';

      controls.forEach(control => {
        control?.clearValidators();
        control?.setErrors(null);
        control?.updateValueAndValidity();
      });

      spouseForm.reset({}, { emitEvent: false });

      this.spouseDetailsFormValid.set('Completed');
    }

    spouseForm.updateValueAndValidity();
  }


  private hasQuestionnaireStarted(sectionName: string): boolean {

    const section =
      this.formGroup.get(sectionName) as FormGroup;

    return Object.values(section.controls)
      .some((question: any) =>
        question.get('answer')?.value !== null
      );

  }
  private updateSectionStatus(
    sectionName: string,
    initialValue: any,
    statusSignal: WritableSignal<string>
  ): void {

    const section =
      this.formGroup.get(sectionName) as FormGroup;

    const currentValue =
      section.getRawValue();

    let anyFilled: boolean;

    if (sectionName.startsWith('questionnaire')) {

      anyFilled =
        this.hasQuestionnaireStarted(sectionName);

    } else {

      anyFilled =
        Object.values(currentValue)
          .some(v => String(v ?? '').trim() !== '');

    }

    // Read-only section
    if (section.status === 'DISABLED') {

      statusSignal.set('Completed');
      return;

    }

    // Questionnaire-specific logic
    if (sectionName.startsWith('questionnaire')) {

      if (!anyFilled) {

        statusSignal.set('Not Started');

      } else if (section.dirty) {

        statusSignal.set('In Progress');

      } else if (section.valid) {

        if (this.workflowStatus == 'RETURNED') {

          const verifiedFlag = Object.values(section.getRawValue()).every(
            (item: any) => item.isVerified
          );
          if (verifiedFlag) {
            statusSignal.set('Verified');

          } else {
            statusSignal.set('Action Required');
          }

        } else {
          statusSignal.set('Completed');
        }

      } else {

        statusSignal.set('In Progress');

      }

      return;

    }

    // marital logic for Personal, Spouse,
    if (sectionName === 'spouseInfo') {

      const maritalStatus =
        this.formGroup.get('personalInfo.maritalStatus')?.value;
      if (sectionName === 'spouseInfo') {

        const maritalStatus =
          this.formGroup.get('personalInfo.maritalStatus')?.value;

        if (
          maritalStatus?.toLowerCase() !== 'married'
        ) {

          statusSignal.set('Completed');
          return;

        } else if (section.invalid) {

          statusSignal.set('In Progress');
          return;

        }

      }

    }

    // Existing logic for Personal, Spouse, Miscellaneous
    const hasChanged =
      JSON.stringify(initialValue) !==
      JSON.stringify(currentValue);

    if (!anyFilled) {

      statusSignal.set('Not Started');

    } else if (hasChanged) {

      statusSignal.set('In Progress');

    } else if (section.valid) {

      statusSignal.set('Completed');

    } else {

      statusSignal.set('In Progress');

    }
  }

  handleFormStatus() {

    this.formGroup.get('personalInfo')
      ?.valueChanges.subscribe(() => {

        this.updateSectionStatus(
          'personalInfo',
          this.initialPersonalValue,
          this.personalDetailsFormValid

        );


      });

    this.formGroup.get('spouseInfo')
      ?.valueChanges.subscribe(() => {

        this.updateSectionStatus(
          'spouseInfo',
          this.initialSpouseValue,
          this.spouseDetailsFormValid
        );


      });

    this.formGroup.get('questionnaire1')
      ?.valueChanges.subscribe(() => {


        this.updateSectionStatus(
          'questionnaire1',
          this.initialQuestionnaire1Value,
          this.questionnaire1FormValid
        );


      });

    this.formGroup.get('questionnaire2')
      ?.valueChanges.subscribe(() => {

        this.updateSectionStatus(
          'questionnaire2',
          this.initialQuestionnaire2Value,
          this.questionnaire2FormValid
        );

      });

    this.formGroup.get('questionnaire3')
      ?.valueChanges.subscribe(() => {

        this.updateSectionStatus(
          'questionnaire3',
          this.initialQuestionnaire3Value,
          this.questionnaire3FormValid
        );

      });

    if (this.loggedInRole !== 'Advisor') {

      this.formGroup.get('questionnaire4')
        ?.valueChanges.subscribe(() => {

          this.updateSectionStatus(
            'questionnaire4',
            this.initialQuestionnaire4Value,
            this.questionnaire4FormValid
          );

        });

    }

    this.formGroup.get('miscellaneous')
      ?.valueChanges.subscribe(() => {

        this.updateSectionStatus(
          'miscellaneous',
          this.initialMiscellaneousValue,
          this.miscellaneousFormValid
        );

      });

  }



  changeIndex(index: number) {
    this.currentStep = index;
  }
  //Form Permission Enine
  private applyPermissions(): void {

    this.canUserEdit = false;

    // Form Fillers
    if (
      [
        'Advisor',
        'Manager',
        'Director'
      ].includes(this.loggedInRole)
    ) {

      this.canUserEdit =
        [
          'NOT_STARTED',
          'IN_PROGRESS',
          'RETURNED'
        ].includes(this.workflowStatus);

    }

    this.updateFormMode();

  }
  //Form Mode decider
  private updateFormMode(): void {

    if (this.canUserEdit) {


      this.enableAdvisorMode();

    } else {

      this.enableReadOnlyMode();

    }

  }

  //User mode
  private enableAdvisorMode(): void {

    this.formGroup.enable();

    [
      'questionnaire1',
      'questionnaire2',
      'questionnaire3',
      'questionnaire4'
    ].forEach(section => {

      const group = this.formGroup.get(section) as FormGroup;

      if (!group) {
        console.warn(`Form group '${section}' not found`);
        return;
      }
      this.formGroup.get('personalInfo.fullName')?.disable();
      this.formGroup.get('personalInfo.nric')?.disable();
      this.formGroup.get('personalInfo.email')?.disable();
      this.formGroup.get('personalInfo.branch')?.disable();
      this.formGroup.get('personalInfo.nationality')?.disable();
      this.formGroup.get('personalInfo.otherNationality')?.disable();
      this.formGroup.get('personalInfo.fin_No')?.disable();
      this.formGroup.get('personalInfo.race')?.disable();
      this.formGroup.get('personalInfo.dob')?.disable();
      this.formGroup.get('personalInfo.repcode')?.disable();
      this.formGroup.get('personalInfo.countryofbirth')?.disable();
      this.formGroup.get('personalInfo.raceSpecify')?.disable();
      this.formGroup.get('personalInfo.representative_no')?.disable();
      this.formGroup.get('personalInfo.maritalStatus')?.disable();
      this.formGroup.get('personalInfo.address')?.disable();
      this.formGroup.get('personalInfo.homenumber')?.disable();
      this.formGroup.get('personalInfo.mobilenumber')?.disable();



      if (group?.controls) {
        Object.values(group.controls).forEach((question: any) => {

          question.get('managerComment')?.disable();
          question.get('isVerified')?.disable();

          if (this.workflowStatus == 'RETURNED') {
            if (question.get('isVerified')?.value == true) {
              question?.disable();
            }

          }

          // file exists -> disable No Attachment
          if (
            question.get('attachment.fileName')?.value
          ) {

            question.get('noAttachment')
              ?.disable({
                emitEvent: false
              });

          }

          // no attachment selected -> disable attachment group
          if (
            question.get('noAttachment')?.value
          ) {

            question.get('attachment')
              ?.disable({
                emitEvent: false
              });

          }

        });

      }

    });

  }

  private enableReadOnlyMode(): void {

    this.formGroup.disable();

  }

  //Section status validation update
  getSectionStatus(
    sectionName: string
  ): 'Not Started' | 'In Progress' | 'Completed' {

    const savedStatus =
      this.sectionStatuses[sectionName];

    if (savedStatus === 'Completed') {
      return 'Completed';
    }

    const questionnaireSections = [
      'questionnaire1',
      'questionnaire2',
      'questionnaire3',
      'questionnaire4'
    ];

    if (
      questionnaireSections.includes(sectionName)
    ) {
      return this.getQuestionnaireStatus(
        sectionName
      );
    }

    return this.getSimpleSectionStatus(
      sectionName
    );
  }

  private getSimpleSectionStatus(
    sectionName: string
  ): 'Not Started' | 'In Progress' | 'Completed' {

    const section = this.formGroup.get(sectionName) as FormGroup;

    if (!section) {
      return 'Not Started';
    }

    const values = section.getRawValue();

    const hasValue = Object.values(values).some(
      value =>
        value !== null &&
        value !== undefined &&
        value !== ''
    );

    if (!hasValue) {
      return 'Not Started';
    }

    // if (section.valid) {
    //   return 'Completed';
    // }

    return 'In Progress';
  }

  private getQuestionnaireStatus(
    sectionName: string
  ): 'Not Started' | 'In Progress' | 'Completed' {

    const section = this.formGroup.get(sectionName) as FormGroup;

    if (!section) {
      return 'Not Started';
    }

    const questions = Object.values(section.controls);

    const hasStarted = questions.some((control: any) => {

      const value = control.getRawValue();

      return (
        value.answer !== null ||
        (value.entityCount ?? '').toString().trim() !== '' ||
        value.noAttachment === true ||
        (value.noAttachmentReason ?? '').trim() !== '' ||
        (value.attachment?.fileName ?? '').trim() !== ''
      );
    });

    if (!hasStarted) {
      return 'Not Started';
    }

    // if (section.valid) {
    //   return 'Completed';
    // }

    return 'In Progress';
  }







  // API integrations
  async getDropdownOptions() {

    const responseData = await this.adservice
      .getDropdownOptions()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });



    if (responseData.status === HttpStatusCode.Ok) {
      this.nationalities = responseData.data.responsedata.constants.nationality_list;
      this.countries = responseData.data.responsedata.constants.country_list;
    }
  }

  private getQuestionnaireName(categoryName: string): string {

    if (categoryName.startsWith('businessInterests_')) {
      return 'questionnaire1';
    }

    if (categoryName.startsWith('generalInformation_')) {
      return 'questionnaire2';
    }

    if (categoryName.startsWith('fitPropercriteria_')) {
      return 'questionnaire3';
    }

    if (categoryName.startsWith('Supervisor attestation_')) {
      return 'questionnaire4';
    }

    return '';
  }

  async loadDeclarationDetails() {
    const payload: GetdetailsModel = {
      uadsId: 0,
      userPiasCode: this.sessionservice.getCurrentRepCode()
    };


    this.setSprinner.set(true);

    const response = await this.adservice.getDeclarationDetails(payload)
      .then((response) => { // Force the type to 'any' instead of 'any[]'
        // console.log('Data received successfully:', dashboardList);
        return JSON.parse(response);

      })
      .catch((error) => {
        console.error('Error fetching dashboard data:', error.message);
      });

    this.setSprinner.set(false);

    if (response.status === HttpStatusCode.Ok) {
      const personal = response.data.responsedata.personalinformation;
      const nationalityValue =
        personal?.nationality ?? '';

      const isSplitFormat =
        nationalityValue.startsWith('others,') ||
        nationalityValue.startsWith('Singapore Permanent Resident,');

      const nationality =
        isSplitFormat
          ? nationalityValue.split(',')[0]
          : nationalityValue;

      const otherNationality =
        isSplitFormat
          ? nationalityValue.split(',')[1]
          : nationalityValue === 'Singapore Citizen'
            ? 'Singaporean'
            : '';

      // Personal Info
      this.formGroup.get('personalInfo')?.patchValue({
        fullName: personal?.fullName,
        representative_no: personal?.masRepNo,
        branch: personal?.branch,
        repcode: personal?.piasRepCode,
        nric: personal?.nricNo,
        nationality,
        otherNationality,
        countryofbirth: personal?.countryofbirth,
        fin_No: personal?.finPassport,
        email: personal?.personalEmail,
        race: personal?.race,
        maritalStatus: personal?.martialStatus,
        address: personal?.userAddress,
        homenumber: personal?.houseNo,
        mobilenumber: personal?.mobile
      });
      // this.formGroup.controls['otherNationality']?.setValue('Singaporean');

      this.initialPersonalValue = structuredClone(
        (this.formGroup.get('personalInfo') as FormGroup).getRawValue()
      );



      // Spouse
      this.formGroup.get('spouseInfo')?.patchValue({
        spousename: personal?.spouseName,
        spouse_no: personal?.spouseNricNo,
        spouse_dob:
          personal?.spouseDob &&
            !personal.spouseDob.startsWith('1000-01-01')
            ? new Date(personal.spouseDob)
            : null,
        spouse_occupation: personal?.spouseOccupation,
        spouse_employer: personal?.spouseEmployer

      }

      );
      this.handleMartialChanges(
        this.formGroup.get('personalInfo.maritalStatus')?.value
      );

      this.initialSpouseValue = structuredClone(
        (this.formGroup.get('spouseInfo') as FormGroup).getRawValue()
      );

      this.spouseDetailsFormValid.set('Completed');


      // Miscellaneous
      this.formGroup.get('miscellaneous')?.patchValue(
        {
          additionalInfo: personal?.additionalInformation
        }


      );

      this.initialMiscellaneousValue = structuredClone(
        (this.formGroup.get('miscellaneous') as FormGroup).getRawValue()
      );




      response.data.responsedata.questionset.forEach((item: any) => {
        const questionnaire =
          this.getQuestionnaireName(item?.categoryName);

        const questionGroup = this.formGroup.get(
          `${questionnaire}.${item.categoryName}`
        ) as FormGroup;

        if (!questionGroup) {
          // console.warn('Question not found:', item.categoryName);
          return;
        }

        questionGroup.patchValue(
          {
            answer: item?.adviserBooleanResponse === 'True' ? true : item?.adviserBooleanResponse === 'False' ? false : '',
            entityCount: item?.adviserResponse,
            attachment: {
              fileName: item?.adviserAttachment,
              documentPath: item?.adviserAttachment
            },
            noAttachment: item?.adviserBooleanAttachment === 'False' ? false : true,
            noAttachmentReason: item?.adviserCommentAttachment,
            isVerified: item?.dsuResponse === 'NotChecked' ? false : true,
            managerComment: item.comments != null ? item?.comments[0].user_comment : '',
            advisorComment: item.advisorcomments != null ? item?.advisorcomments[0].user_comment : '',
          },
          {
            emitEvent: false
          });


      });
      this.initialQuestionnaire1Value =
        structuredClone(
          this.formGroup
            .get('questionnaire1')
            ?.getRawValue()
        );

      this.initialQuestionnaire2Value =
        structuredClone(
          this.formGroup
            .get('questionnaire2')
            ?.getRawValue()
        );

      this.initialQuestionnaire3Value =
        structuredClone(
          this.formGroup
            .get('questionnaire3')
            ?.getRawValue()
        );

      this.initialQuestionnaire4Value =
        structuredClone(
          this.formGroup
            .get('questionnaire4')
            ?.getRawValue()
        );
      this.applyPermissions();
    } else {
      if (response.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (response.code === HttpStatusCode.Unauthorized) {
        this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }

    }

  }

  private mapDeclarationStatus(status: string): any {

    switch (status?.trim().toUpperCase()) {

      case 'NOT_STARTED':
      case 'NOT STARTED':
        return 'NOT_STARTED';

      case 'IN_PROGRESS':
      case 'IN PROGRESS':
        return 'IN_PROGRESS';

      case 'SUBMITTED':
        return 'SUBMITTED';

      case 'IN_REVIEW':
      case 'IN REVIEW':
        return 'IN_REVIEW';

      case 'RETURNED':
        return 'RETURNED';

      case 'APPROVED':
        return 'APPROVED';

      default:
        return 'NOT_STARTED';
    }

  }

  async getdeclarationstatus() {

    this.setSprinner.set(true);
    const responseData = await this.adservice.getdeclarationstatus()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      const apiStatus = responseData?.data.responsedata.anndeclareStatus;

      this.workflowStatus =
        this.mapDeclarationStatus(apiStatus);

      const role =
        this.sessionservice.getCurrentUserRole();

      this.loggedInRole = role as any;

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }


  }


  // Getter - points correctly to 'this.formGroup'
  getQuestionGroup(sectionName: string, questionId: string) {
    return this.formGroup.get(sectionName + '.' + questionId);
  }

  /**
   * Setup conditional validators for nationality field
   */

  async personalsave(processType: string) {
    const sectionGroup = this.formGroup.get('personalInfo') as FormGroup;

    // const username = this.sessionservice.getCurrentUserPersonName();

    // if (sectionGroup.invalid) {
    //   sectionGroup.markAllAsTouched();
    //   return;
    // }
    if (sectionGroup.invalid) {
      this.showValidationErrors = true;
      return;
    }

    const formValues = sectionGroup.getRawValue();

    const payload: PersonalsectionpostModel = {
      email: formValues.email,
      uname: formValues.fullName,
      fullName: formValues.fullName,
      masRepNo: formValues.representative_no,
      branch: formValues.branch,
      piasRepCode: formValues.repcode,
      nricNo: formValues.nric,
      nationality: formValues.nationality,
      prNationality: formValues.otherNationality,
      finPassport: formValues.fin_No,
      personalEmail: formValues.email,
      race: formValues.race,
      martialStatus: formValues.maritalStatus,
      userAddress: formValues.address,
      houseNo: formValues.homenumber,
      mobile: formValues.mobilenumber,
      countryofbirth: formValues.countryofbirth,
    };

    this.setSprinner.set(true);
    const response = await this.adservice.savepersonaldetails(payload)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (response.status === HttpStatusCode.Ok) {

      this.sectionStatuses['personalInfo'] =
        processType === 'Complete'
          ? 'Completed'
          : 'In Progress';
      return response.data.responsedata || [];
    } else {
      if (response.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (response.code === HttpStatusCode.Unauthorized) {
        this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }

    // const maritalStatus = this.formGroup.get('personalInfo.maritalStatus')?.value;
    // if (maritalStatus !== 'Married') {
    //   this.formGroup.get('spouseInfo')?.reset();
    //   this.sectionStatuses['spouseInfo'] = 'Completed';
    //   return null; 
    // }
    // console.log('Saved Successfully', response);

  }
  async spousesave(processType: string) {
    const sectionGroup = this.formGroup.get('spouseInfo') as FormGroup;
    // const username = this.sessionservice.getCurrentUserPersonName();

    if (sectionGroup.invalid) {
      sectionGroup.markAllAsTouched();
      return;
    }

    const formValues = sectionGroup.getRawValue();

    const payload: SpousesectionpostModel = {
      spouseName: formValues.spousename,
      spouseNricNo: formValues.spouse_no,
      spouseDob: formValues.spouse_dob,
      spouseOccupation: formValues.spouse_occupation,
      spouseEmployer: formValues.spouse_employer

    };

    this.setSprinner.set(true);
    const response = await this.adservice.savespousedetails(payload)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (response.status === HttpStatusCode.Ok) {

      this.sectionStatuses['spouseInfo'] =
        processType === 'Complete'
          ? 'Completed'
          : 'In Progress';
      return response.data.responsedata || [];
    } else {
      if (response.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (response.code === HttpStatusCode.Unauthorized) {
        this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }

  }
  async miscellaneoussave(processType: string) {
    const sectionGroup = this.formGroup.get('miscellaneous') as FormGroup;
    // const username = this.sessionservice.getCurrentUserPersonName();

    if (sectionGroup.invalid) {
      sectionGroup.markAllAsTouched();
      return;
    }

    const formValues = sectionGroup.getRawValue();

    const payload: MiscellanioussectionpostModel = {
      additionalInformation: formValues.additionalInfo,


    };

    this.setSprinner.set(true);
    const response = await this.adservice.savemicellaneous(payload)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (response.status === HttpStatusCode.Ok) {

      this.sectionStatuses['miscellaneous'] =
        processType === 'Complete'
          ? 'Completed'
          : 'In Progress';
      return response.data.responsedata || [];
    } else {
      if (response.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (response.code === HttpStatusCode.Unauthorized) {
        this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }

  }

  async QuestionsaveAndContinue(sectionName: string, processType: string) {
    const sectionGroup = this.formGroup.get(sectionName) as FormGroup;

    const formValues = sectionGroup.getRawValue();

    const questionIds = Object.keys(formValues);
    const rawUserId = this.sessionservice.getCurrentRepCode();
    // console.log('Raw User ID from Session:', rawUserId);

    const answeredQuestionslength = questionIds.filter(id => {
      const answer = formValues[id]?.answer;
      return answer !== null
    }).length;

    // 1. The .map() loop should ONLY return the object data to build the array
    const payloadArray = questionIds
      .map(questionId => {
        const qData = formValues[questionId];

        // RETURN the object directly here to populate the array
        return {
          questioncategory: questionId,
          QuestionID: 0,
          UserID: 0, // Set to 0 or a default value as per your backend requirements
          userPiasCode: rawUserId || 'Unknown', // Fallback to 'Unknown' if session value is missing
          adviserBooleanResponse: qData.answer === true ? 'True' : qData.answer === false ? 'False' : '',
          adviserResponse: qData.entityCount ? qData.entityCount.toString() : '',
          adviserAttachment: qData.attachment?.fileName || '',
          adviserBooleanAttachment: qData.noAttachment === true ? 'True' : 'False',
          adviserCommentAttachment: qData.noAttachmentReason || '',
          adviserresponsecomment: qData.advisorComment || ''

        };
      }); // <-- The map loop ends completely here!

    // console.log('Sending sanitized payload array:', payloadArray);
    const payload: DeclarationSectionPayload = {
      processtype: processType,
      questionset: payloadArray
    };
    // console.log('Final Payload:', payload);
    const totalQuestions = Object.keys(formValues).length;

    const isPartialSave = answeredQuestionslength > 0 && answeredQuestionslength < totalQuestions;
    this.setSprinner.set(true);
    const result = await this.adservice.savedeclarationquestion(payload)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (result.status === HttpStatusCode.Ok) {
      if (isPartialSave) {
        this.snackmessage.openSuccessSnackBar(
          'Saved Successfully'
        );
      }
      sectionGroup.markAllAsTouched();
      this.getdeclarationstatus();
      return result.data.responsedata || [];
    } else {
      if (result.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (result.code === HttpStatusCode.Unauthorized) {
        this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }


  }

  // File Handling Methods
  onNoAttachmentChange(
    checked: boolean,
    section: string,
    questionId: string
  ) {

    const questionGroup =
      this.getQuestionGroup(section, questionId);

    if (checked) {

      questionGroup?.get('attachment')?.patchValue({
        file: null,
        fileName: '',
        documentPath: ''
      });

    }

  }

  hasAttachment(section: string, questionId: string): boolean {
    return !!this.getQuestionGroup(section, questionId)?.get('attachment.fileName')?.value;
  }

  async onFileChange(
    event: Event,
    sectionName: string,
    questionId: string
  ) {
    const input = event.target as HTMLInputElement;

    if (!input.files?.length) {
      return;
    }


    const file = input.files[0];

    const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/png'
    ];

    const maxSize = 5 * 1024 * 1024;

    const questionGroup =
      this.getQuestionGroup(sectionName, questionId);

    const attachmentGroup =
      questionGroup?.get('attachment');

    // Clear previous errors
    attachmentGroup?.setErrors(null);

    // File type validation
    if (!allowedTypes.includes(file.type)) {

      attachmentGroup?.setErrors({
        invalidFileType: true
      });

      input.value = '';
      return;
    }

    // File size validation
    if (file.size > maxSize) {

      attachmentGroup?.setErrors({
        invalidFileSize: true
      });

      input.value = '';
      return;
    }

    try {

      const uploadResponse =
        await this.adservice.uploadfile(file);

      const uploadedPath =
        uploadResponse.responsedata;

      const uploadedFileName =
        uploadedPath.split('/').pop();

      attachmentGroup?.patchValue({
        file,
        fileName: uploadedFileName,
        documentPath: uploadedPath

      });



      attachmentGroup?.setErrors(null);

      questionGroup?.updateValueAndValidity();

    } catch (error) {

      attachmentGroup?.setErrors({
        uploadFailed: true
      });

      console.error(error);
    }
  }

  async removeFile(
    sectionName: string,
    questionId: string
  ) {

    const questionGroup =
      this.getQuestionGroup(sectionName, questionId);

    const documentPath =
      questionGroup?.get('attachment.documentPath')?.value;

    try {

      if (documentPath) {

        await this.adservice.removefile(
          documentPath
        );

      }

      questionGroup?.get('attachment')?.reset({
        file: null,
        fileName: '',
        documentPath: ''
      });

      questionGroup?.get('noAttachment')?.enable(
        { emitEvent: false }
      );

      questionGroup?.get('noAttachment')?.setValue(
        false,
        { emitEvent: false }
      );

      const fileKey =
        sectionName + '_' + questionId;

      this.uploadedFiles.delete(fileKey);

      // console.log('File removed successfully');

    } catch (error) {

      console.error(
        'Failed to remove file',
        error
      );

    }

  }

  private getQuestionNumber(
    categoryName: string,
    sectionName: string
  ): number {

    const questionMap: Record<string, any[]> = {
      questionnaire1: questionnaire1Questions,
      questionnaire2: questionnaire2Questions,
      questionnaire3: questionnaire3Questions,
      questionnaire4: questionnaire4Questions
    };

    const questions =
      questionMap[sectionName] || [];

    return questions.findIndex(
      q => q.id === categoryName
    ) + 1;
  }


  async saveAndContinue(
    sectionName: string
  ): Promise<void> {

    const formValidators = [
      this.personalDetailsFormValid,
      this.spouseDetailsFormValid,
      this.questionnaire1FormValid,
      this.questionnaire2FormValid,
      this.questionnaire3FormValid,
      this.questionnaire4FormValid,
      this.miscellaneousFormValid,
    ];
    try {

      const response =
        await this.executeSectionSave(
          sectionName,
          'Complete'
        );
      if (response === undefined) {
        return;
      }
      const hasStarted = this.hasQuestionnaireStarted(sectionName);

      const changedQuestions =
        (Array.isArray(response)
          ? response
          : response?.responsedata ?? [])
          .map((item: any) => ({
            ...item,
            questionNo: this.getQuestionNumber(
              item.categoryName,
              sectionName
            )
          }));


      if (this.formGroup.controls[sectionName].valid) {
        // console.log(changedQuestions.length)
        if (changedQuestions.length !== 0) {
          const dialogRef =
            this.dialog.open(
              AdFormSubmitDialog,
              {
                width: '70vw',
                maxWidth: '70vw',
                disableClose: true,
                position: { right: '150px' },
                panelClass: 'center-dialog',
                data: {
                  changedQuestions,
                  sectionName
                }
              }
            );

          dialogRef.afterClosed()
            .subscribe(async result => {

              const step = this.currentStep;

              if (result?.action === 'confirm') {

                formValidators[step]?.set('Completed');

                this.snackmessage.openSuccessSnackBar(
                  'Section Completed Successfully'
                );

                if (this.loggedInRole !== 'Advisor') {
                  this.currentStep = step + 1;
                } else if (step === 4) {
                  this.currentStep = step + 2;
                } else {
                  this.currentStep = step + 1;
                }
              }

              if (result?.action === 'cancel') {
                formValidators[step]?.set('In Progress');
              }

            });

        }
        else {
          formValidators[this.currentStep].set('Completed');
          this.currentStep++;
          this.getdeclarationstatus();
        }
      }
      else {
        formValidators[this.currentStep].set('In Progress');
        // this.snackmessage.openSuccessSnackBar("Saved Successfully");
        // this.currentStep++;
      }
    } catch (error) {

      console.error(
        'Save & Continue Failed:',
        error
      );

    }

  }
  private async executeSectionSave(
    sectionName: string,
    processType: string
  ): Promise<any> {

    switch (sectionName) {

      case 'personalInfo':

        return await this.personalsave(
          processType
        );

      case 'spouseInfo':

        return await this.spousesave(
          processType
        );

      case 'miscellaneous':
        return await this.miscellaneoussave(
          processType
        );

      case 'questionnaire1':
      case 'questionnaire2':
      case 'questionnaire3':
      case 'questionnaire4':
        return await this.QuestionsaveAndContinue(
          sectionName,
          processType
        );

    }

  }


  public submitForm(): void {
    let submitflag = signal(false);
    const isValidStatus = (status: string) =>
      ['Completed', 'Verified'].includes(status);

    const canSubmit =
      isValidStatus(this.personalDetailsFormValid()) &&
      isValidStatus(this.spouseDetailsFormValid()) &&
      isValidStatus(this.questionnaire1FormValid()) &&
      isValidStatus(this.questionnaire2FormValid()) &&
      isValidStatus(this.questionnaire3FormValid()) &&
      isValidStatus(this.miscellaneousFormValid()) &&
      (this.loggedInRole === 'Advisor' || isValidStatus(this.questionnaire4FormValid()));

    submitflag.set(canSubmit);
    if (submitflag()) {
      const dialogRef = this.dialog.open(ConfirmPopupComponent, {
        width: '500px',
        disableClose: true,
        data: {
          message: 'Are you sure you want to submit this Application?',
          hidecancel: false,
        }
      });

      dialogRef.afterClosed().subscribe(async result => {
        if (result.data === true) {
          this.setSprinner.set(true);
          const response = await this.adservice.getdeclarationapproval()
            .then((response) => {
              return JSON.parse(response);
            })
            .catch((error) => {
              // console.error(error);
              return error;
            });
          this.setSprinner.set(false);
          if (response.status === HttpStatusCode.Ok) {

            this.loadDeclarationDetails();
            this.getdeclarationstatus();
            this.applyPermissions();
            window.location.reload();
          } else {
            if (response.code === HttpStatusCode.BadRequest) {
              // Display notification on API failure.
              this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
            }
            if (response.code === HttpStatusCode.Unauthorized) {
              this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");
              this.router.navigate(['/login']);
            }
          }

        } else {
          // console.log('User cancelled');

        }
      });
    } else {
      this.snackmessage.openWarningSnackBar('Please complete all sections before submitting.');
    }

  }
}
